module.exports = __webpack_public_path__ + "img/1.b30cb4d3.png";